import apiClient from './axios'

export const authApi = {
  // Register
  register(data) {
    return apiClient.post('/auth/register', data)
  },

  // Login
  login(credentials) {
    return apiClient.post('/auth/login', credentials)
  },

  // Logout
  logout() {
    return apiClient.post('/auth/logout')
  },

  // Get current user
  me() {
    return apiClient.get('/me')
  },

  // Update profile
  updateProfile(data) {
    return apiClient.put('/me', data)
  },

  // Change password
  changePassword(data) {
    return apiClient.post('/me/password', data)
  },

  // Forgot password - send reset link
  forgotPassword(email) {
    return apiClient.post('/auth/forgot-password', { email })
  },

  // Reset password with token
  resetPassword(data) {
    return apiClient.post('/auth/reset-password', data)
  },
}

